import {Request} from "../core/request"
import {AuthHeader, removeToken, saveToken} from "../core/token";

export type Token = {
    token: string;
    expire: string;
    status: string;
};

export async function refreshToken() {
    return await Request.post<Token>('/auth/refresh', {headers: AuthHeader()});
}

export async function login(username: string, password: string) {
    const response = await Request.post("/auth/login", {
        name: username,
        password: password,
    })
    if (response && response.data.token) {
        saveToken(response.data);
    }
    return response;
}

export async function logout() {
    removeToken();
    return Request.post<Token>('/auth/logout', {}, {headers: AuthHeader()});
}

export type RegisterRequest = {
    // verify_code_id: string;
    // verify_code_value: string;
    name: string;
    password: string;
    email: string;
    emailCode: string;
    userCoder: string;
}

export type ResetPasswordRequest = {
    password: string;
    email: string;
    emailCode: string;
}

export async function register(registerRequest: RegisterRequest) {
    return await Request.post(`/auth/register`, registerRequest);
}

export async function getRegisterEmail(email: string, name: string) {
    return await Request.post(`/auth/register_email`, {
        email: email,
        name: name,
    });
}

export async function getResetPasswordEmail(email: string, name: string) {
    return await Request.post(`/auth/reset_password_email`, {
        email: email,
        name: name,
    });
}


export async function getResetPassword(resetPasswordRequest: ResetPasswordRequest) {
    return await Request.post(`/auth/reset_password`, resetPasswordRequest);
}

export async function updatePassword(oldPassword: string, newPassword: string) {
    return await Request.post(`/auth/updatePassword`, {
        orgPassword: oldPassword,
        newPassword: newPassword,
    }, {headers: AuthHeader()});
}


export async function sendInitPasswordResetEmail(email: string) {
    return await Request.post(`/auth/reset_init_password_email`, {
        email: email,
    }, {headers: AuthHeader()});
}

export async function resetInitPassword(initPassword: string, newPassword: string, email?:string, emailCode?: string) {
    return await Request.post(`/auth/reset_password_with_init_password`, {
        initPassword: initPassword,
        newPassword: newPassword,
        email: email,
        emailCode: emailCode,
    }, {headers: AuthHeader()});

}